<template>
    <div>
        <b>{{ propAccount.movementType.name }}</b><br>
        {{ propAccount.ar.description }}<br>
        <div class="row align-items-start">
            <div class="col-2"><span class="text-muted">Data: </span></div>
            <div class="col">{{ $utils.dateStringFormat(propAccount.ar.dueDate) }}</div>
            <div class="col-2"><span class="text-muted">Valor: </span></div>
            <div class="col text-right">{{ $utils.numberFormat(propAccount.ar.totalValue) }}</div>
        </div>
        <hr>
        <div class="row align-items-start">
            <div class="col-2"><span class="text-muted"></span></div>
            <div class="col"></div>
            <div class="col-2"><span class="text-muted">Saldo: </span></div>
            <div class="col text-right">{{ $utils.numberFormat(accounts.balance) }}</div>
        </div>
        <hr>

        <b-form enctype="multipart/form-data">
                
            <b-row>
                <b-col md="12">
                    <b-form>
                    <b-form-group
                    description=""
                    label="Comprovante de Transferência"
                    label-for="voucher"
                    >
                    <b-form-textarea
                        id="voucher"
                        v-model="voucher"
                        placeholder=""
                        rows="3"
                    ></b-form-textarea>
                    </b-form-group>          
                    </b-form>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Anexo"
                    label-for="attachment"
                    :label-cols="3"
                    :horizontal="false">

                        <file-drop-area-component v-model="fileToSend"></file-drop-area-component>

                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Forma de Pagamento"
                    label-for="mop"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-select id="mop"
                            v-model="mopId"
                            :plain="true"
                            :options="mopDDL"
                            value="Forma de Pagamento">
                        </b-form-select>
                    </b-form-group>          
                </b-col>
            </b-row>

        </b-form>
        

        <b-input-group class="mb-4">
              <div class="text-danger" v-if="errorMessage && errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ errorMessage }}</div>
        </b-input-group>
    
        <div slot="footer" class="text-right">
        
        <b-button variant="vine" class="mr-1 btn-brand" @click="payAccount()" :disabled="sendingPayment || accounts.balance <= propAccount.ar.totalValue"><i class="fa fa-money"></i><span>Pagar com Saldo Em Conta</span></b-button>
        <b-button variant="github" class="mr-1 btn-brand" @click="sendVoucher()" :disabled="!mopId || mopId <= 0 || sendingPayment || (voucher.length <= 0 && fileToSend == null)"><i class="fa fa-send"></i><span>Enviar Comprovante</span></b-button>
        
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import axios from "axios";
/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)
Vue.use(VueNotifications, options)
/* Toast - End */

export default {
  name: "AccountComponentPaymentModal",
  components: {
    FileDropAreaComponent
  },
  props: {
    account: Object,
  },
  data() {
    return {
        mopId: null,
        mopDDL: [],
        sendingPayment: false,
        accounts: [],
        fileToSend: null,
        voucher: '',
        errorMessage: ''
    }
  },
  computed: {
    propAccount() {
      return this.account
    }
  },
  methods: {

    async payAccount() {
        this.sendingPayment = true;
        var s = this;
        var currentUser = this.$store.state.currentUser;

        var data = {
            franchisePaymentId: this.propAccount.id,
            mopId: 100,
            uid: currentUser.id,
            sid: currentUser.sid
        }

        await axios.post(
            this.$store.state.ws_url + "/franchise/payment/pay",
            data
        ).then(function(resp) {           
            s.sendingPayment = false
            s.$emit('resp', resp.data)
            
        })
        .catch(function(error) {
            s.sendingPayment = false
            toast ({
                type: VueNotifications.types.error,
                title: 'Enviar Mensagem',
                message: 'Erro ao pagar com saldo: ' + resp.data.obj,
                timeout: 2000
            });            
        });

    },

    async sendAccountsPayment() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        
        let formData = new FormData();
        formData.append('franchisePaymentId', this.propAccount.id)
        formData.append('files', this.fileToSend)
        formData.append('voucher', this.voucher)
        formData.append('mopId', this.mopId)
        formData.append('uid', currentUser.id)
        formData.append('sid', currentUser.sid)

        //console.log(this.$store.state.ws_url + "/franchise/payment/voucher")

        //console.log(formData)

        await axios.post(
            this.$store.state.ws_url + "/franchise/payment/voucher",
            formData
        ).then(function(resp) {
            s.mopId = null
            s.voucher = ''
            s.fileToSend = null
            s.$emit('resp', resp.data)
        })
        .catch(function(error) {
            console.log(error)
            toast ({
                type: VueNotifications.types.error,
                title: 'Enviar Comprovante de Pagamento',
                message: 'Erro enviar comprovante de pagamento',
                timeout: 2000
            });            
        });
        
    },

    sendVoucher() {
        if(this.voucher.length > 0 || this.fileToSend) {
            this.sendAccountsPayment();
        }
        else {
            toast ({
                type: VueNotifications.types.error,
                title: 'Informações de Pagamento',
                message: 'Preencha o comprovante de transferência ou anexe um arquivo.',
                timeout: 5000
            })
        }
        
    },
    async refreshAccount() {
      var s = this;
      var currentUser = this.$store.state.currentUser;
      await axios.get(
          this.$store.state.ws_url + "/account?userId=" + this.propAccount.groupUser.user.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
          if(resp.data.obj && resp.data.obj.length > 0) {
            s.accounts = resp.data.obj[0];
          }
          else {
            s.accounts = {
                balance: 0
            }
          }
          
      })
      .catch(function(error) {
          console.log(error);
      });
      
    },
    async getMop() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
    
        await axios.get(
            this.$store.state.ws_url + "/mop/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
            s.mopDDL = resp.data.obj;
        }).catch(function (error) {
            console.log(error);
        });
    }

  },
  mounted: function() {
    this.refreshAccount()
    this.getMop()
    this.mopId = null
  }
  
};
</script>